
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-661cf964!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./../../node_modules/eslint-loader/index.js!./main.vue")

var Component = require("/Users/joshuaking/www/ralph/ralph_pr/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./../../node_modules/eslint-loader/index.js!./main.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-661cf964!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./../../node_modules/eslint-loader/index.js!./main.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/containers/main.vue
// module id = 27
// module chunks = 1